import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GrowAccount } from '@inyova/models';

@Component({
  selector: 'app-grow-investment-amount',
  templateUrl: './grow-investment-amount.component.html',
  styleUrls: ['./grow-investment-amount.component.scss'],
  standalone: false
})
export class GrowInvestmentAmountComponent implements OnInit {
  @Input() growAccount: GrowAccount;
  @Input() initialInvestmentOptions: number[] = [];
  @Input() savingsPlanOptions: number[] = [];

  // Optional parent form (for mobile)
  @Input() parentForm?: FormGroup;
  @Input() riskFormSubmitted?: boolean;

  @Input() investmentPlanData?: { initial_investment: number; monthly_investment: number };

  @Output() formSubmitted = new EventEmitter<{ initial: number; savings: number }>();

  investmentForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    if (!this.initialInvestmentOptions.includes(this.growAccount.minimum_investment)) {
      this.initialInvestmentOptions = [this.growAccount.minimum_investment, ...this.initialInvestmentOptions];
    }

    const initialInvestmentValue = this.investmentPlanData?.initial_investment ?? (this.growAccount.minimum_investment || 0);
    const monthlyInvestmentValue = this.investmentPlanData?.monthly_investment ?? 0;

    if (this.parentForm) {
      if (!this.parentForm.get('investment')) {
        this.parentForm.addControl(
          'investment',
          this.fb.group({
            initial: [initialInvestmentValue, Validators.required],
            savings: [monthlyInvestmentValue ?? 0]
          })
        );
      }
      this.investmentForm = this.parentForm.get('investment') as FormGroup;
    } else {
      this.investmentForm = this.fb.group({
        initial: [initialInvestmentValue, Validators.required],
        savings: [monthlyInvestmentValue]
      });
    }
  }

  get initial() {
    return this.investmentForm.get('initial');
  }

  get savings() {
    return this.investmentForm.get('savings');
  }

  submit(): void {
    if (this.investmentForm.invalid) {
      this.investmentForm.markAllAsTouched();
      return;
    }

    this.formSubmitted.emit({
      initial: this.initial.value,
      savings: this.savings.value
    });
  }
}
